<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" backdrop shadow :visible="!!inspectionID" :right="true"
            no-header-close no-close-on-backdrop no-close-on-esc>
            <template #header="{ }">
                <div class="d-flex align-items-center w-100 justify-content-between">
                    <div class="d-flex align-items-center w-100 mr-2">
                        <div class="text-nowrap" v-if="currentDotInspection">
                            {{ currentDotInspection.record_no }}
                        </div>
                        <!-- <b-button class="ml-5 pe-none d-flex justify-content-center align-items-center w-100px h-40px"
                            :class="inspectionPayload.status === 'New'
                                ? 'new-record'
                                : inspectionPayload.status === 'Urgent'
                                    ? 'urgent-record text-white'
                                    : inspectionPayload.status === 'Open' ? 'open-record' : 'inactive-equipment text-black'"
                            :variant="inspectionPayload.status === 'New' ? 'warning' : inspectionPayload.status === 'Urgent' ? 'danger' : inspectionPayload.status === 'Open' ? 'success' : 'light'">
                            <p class="mb-0">{{ inspectionPayload.status }}</p>
                        </b-button> -->
                    </div>
                    <b-dropdown id="dropdown-divider" text="text" class="load-dropdown mt-0" v-if="allowDeleteRecord">
                        <template slot="button-content">
                            <b-icon class="dots" icon="three-dots"></b-icon>
                        </template>
                        <b-dropdown-item-button @click="showDeleteInspectionModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editInspection.delete') }}</p>
                        </b-dropdown-item-button>
                    </b-dropdown>
                </div>
            </template>
            <div class="body" v-if="currentDotInspection">
                <div class="sidebar-tabs">
                    <div class="bg-white rounded">
                        <v-tabs class="team-tabs mb-0" v-model="activeTab" show-arrows>
                            <v-tab key='info'>{{ $t('editInspection.infoTab') }}</v-tab>
                            <v-tab key='volations'>{{ $t('editInspection.violationsTab') }}</v-tab>
                            <v-tab key='documents'>{{ $t('editInspection.documentsTab') }}</v-tab>
                            <v-tab key='notes'>{{ $t('editInspection.notesTab') }}</v-tab>
                            <v-tab key='activity' v-if="showActivitySection">{{ $t('editInspection.activityTab') }}</v-tab>
                        </v-tabs>
                    </div>
                </div>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item key='info'>
                        <hr class="mt-0" />
                        <div class="d-block text-center mt-4rem">
                            <b-row class="align-items-center px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('editInspection.basicSection') }}
                                </h3>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('addInspection.recordLabel')" class="text-left mb-0">
                                        <b-form-input v-model="currentDotInspection.record_no" disabled type="text"
                                            :placeholder="$t('addInspection.recordPlaceholder')" class="unit"
                                            required></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <div class="text-left select_arrow ">
                                        <label class="state">{{ $t('addInspection.statusLabel') }}</label>
                                        <b-form-select class="f-12" v-model="inspectionPayload.status"
                                            :disabled="!allowUpdateRecord" :options="statusOptions"
                                            @change="onStatusChange" />
                                    </div>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label for="inspection-edit-datepicker" class="state">{{ $t('addInspection.dateLabel')
                                    }}</label>
                                    <date-picker v-model="inspectionPayload.date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="inspectionPayload.date = ''"
                                        :placeholder="$t('editInspection.selectDate')" class="date-picker-custom"
                                        :teleport="'body'" :disabled="!allowUpdateRecord"></date-picker>
                                    <p v-if="errors && errors.date" class="field-error">
                                        {{ errors.date[0] }}
                                    </p>
                                </b-col>
                                <b-col md="6" sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addInspection.startTimeLabel') }}</label>
                                    <b-form-input type="time" class="f-12" v-model="inspectionPayload.start_time"
                                        :disabled="!allowUpdateRecord"></b-form-input>
                                </b-col>
                                <b-col md="6" sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addInspection.endTimeLabel') }}</label>
                                    <b-form-input type="time" class="f-12" v-model="inspectionPayload.end_time"
                                        :disabled="!allowUpdateRecord"></b-form-input>
                                </b-col>
                                <b-col sm="12">
                                    <hr class="mt-4" />
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addInspection.driverLabel') }}</label>
                                        <v-select class="bg_white w-100 f-12" v-model="inspectionPayload.driver"
                                            :disabled="!allowUpdateRecord" :options="driverOptions" item-value="id"
                                            item-text="label" :reduce="(option) => option.id" @search="searchDriver">
                                            <span slot="no-options">
                                                {{ $t('addInspection.searchDriver') }}
                                            </span>
                                        </v-select>
                                        <p v-if="errors && errors.driver" class="field-error">
                                            {{ errors.driver[0] }}
                                        </p>
                                    </div>
                                </b-col>
                                <b-col sm="12">
                                    <div class="text-left select_arrow mt-3">
                                        <label class="state">{{ $t('addInspection.vehicleLabel') }}</label>
                                        <v-select class="bg_white w-100 f-12" :disabled="!allowUpdateRecord"
                                            v-model="inspectionPayload.vehicle" :options="vehicleOptions" item-value="id"
                                            item-text="label" :reduce="(option) => option.id" @search="searchVehicle">
                                            <span slot="no-options">
                                                {{ $t('addInspection.searchVehicle') }}
                                            </span>
                                        </v-select>
                                    </div>
                                </b-col>
                                <b-col sm="12">
                                    <div class="text-left select_arrow mt-3">
                                        <label class="state">{{ $t('addInspection.trailerLabel') }}</label>
                                        <v-select class="bg_white w-100 f-12" :disabled="!allowUpdateRecord"
                                            v-model="inspectionPayload.trailer" :options="trailerOptions" item-value="id"
                                            item-text="label" :reduce="(option) => option.id" @search="searchTrailer">
                                            <span slot="no-options">
                                                {{ $t('addInspection.searchTrailer') }}
                                            </span>
                                        </v-select>
                                    </div>
                                </b-col>
                                <b-col sm="12">
                                    <hr class="mt-4" />
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addInspection.divisionLabel') }}</label>
                                        <v-select class="f-12" :clearable="false" :options="allDivisions"
                                            v-model="inspectionPayload.division" :reduce="(option) => option.id" />
                                    </div>
                                </b-col>
                                <b-col sm="12">
                                    <hr class="mt-4" />
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addInspection.citationsLabel') }}</label>
                                        <v-select class="f-12" @search="searchCitations" :options="allCitations" multiple
                                            :reduce="(option) => option.id" v-model="inspectionPayload.linked_tickets" />
                                        <p v-if="citationsNotClosed" class="field-error">{{
                                            $t('editInspection.citationsNotClosed') }}</p>
                                        <div v-if="inspectionPayload.linked_tickets.length" class="mt-2">
                                            <div v-for="(item, index) in inspectionPayload.linked_tickets" :key="index">
                                                <a class="text-primary f-14 cursor-pointer"
                                                    @click="goToCitationDetails(item, getCitationLabel(item))"><u>{{
                                                        $t('addInspection.goToCitation', { label: getCitationLabel(item) })
                                                    }}</u></a>
                                                <br />
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col sm="12">
                                    <hr class="mt-4" />
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addInspection.levelLabel') }}</label>
                                        <b-form-select v-model="inspectionPayload.level" :disabled="!allowUpdateRecord"
                                            class="f-12" :options="[{
                                                value: null,
                                                text: ''
                                            },
                                            {
                                                value: 'I',
                                                text: '|'
                                            },
                                            {
                                                value: 'II',
                                                text: '||'
                                            },
                                            {
                                                value: 'III',
                                                text: '|||'
                                            }
                                            ]" />
                                    </div>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addInspection.reportLabel') }}</label>
                                    <b-form-input type="text" :disabled="!allowUpdateRecord"
                                        v-model="inspectionPayload.report_number" class="f-12"
                                        :placeholder="$t('addInspection.reportPlaceholder')"></b-form-input>
                                </b-col>
                                <b-col sm="12">
                                    <div class="text-left select_arrow mt-3">
                                        <label class="state">{{ $t('addInspection.stateLabel') }}</label>
                                        <v-select class="bg_white w-100" :disabled="!allowUpdateRecord"
                                            v-model="inspectionPayload.state" :options="states" item-value="id"
                                            item-text="label" :reduce="(option) => option.id">
                                        </v-select>
                                    </div>
                                </b-col>
                                <b-col md="12" class="text-left mt-3">
                                    <label class="state text-left">{{ $t('addInspection.descriptionLabel') }}</label>
                                    <b-form-textarea id="textarea" :disabled="!allowUpdateRecord"
                                        :placeholder="$t('addInspection.notesPlaceholder')" class="f-12" rows="5"
                                        v-model="inspectionPayload.notes"></b-form-textarea>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4 mb-7rem">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addInspection.dataq') }}</h3>
                                <b-col sm="12" class="text-left mb-2">
                                    <b-row>
                                        <b-col sm="12" class="text-left">
                                            <label>{{ $t('addInspection.yesLabel') }}</label>
                                            <b-form-checkbox name="check-button" class="ml-0-6rem"
                                                v-model="inspectionPayload.dataq_section" switch
                                                size="lg"></b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="12" v-if="inspectionPayload.dataq_section">
                                    <b-row>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addInspection.dataqStatusLabel') }}</label>
                                            <b-form-select v-model="inspectionPayload.dataq_status" class="f-12"
                                                :options="dataqStatusOptions" />
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label for="dataq_submitted_date" class="state">{{
                                                $t('addInspection.dataqSubmittedDateLabel') }}</label>
                                            <date-picker v-model="inspectionPayload.dataq_submitted_date"
                                                :formatter="momentFormat" :range-separator="' - '"
                                                @clear="inspectionPayload.dataq_submitted_date = null"
                                                :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom"
                                                :teleport="'body'"></date-picker>

                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label for="dataq_decision_date" class="state">{{
                                                $t('addInspection.dataqDecisionDateLabel')
                                            }}</label>
                                            <date-picker v-model="inspectionPayload.dataq_decision_date"
                                                :formatter="momentFormat" :range-separator="' - '"
                                                @clear="inspectionPayload.dataq_decision_date = null"
                                                :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom"
                                                :teleport="'body'"></date-picker>
                                            <p v-if="dataqDecisionMissing" class="field-error">{{
                                                $t('editInspection.dataqDecisionRequired') }}</p>

                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='violations'>
                        <div class="d-block body">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editInspection.violationsTab')
                                }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    @click='$bvModal.show("modal-violation")' v-if="allowUpdateRecord">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editInspection.addViolation') }}</p>
                                </div>
                            </div>
                            <div class="px-4">
                                <div v-if="violationItems.length === 0"
                                    class="text-center text-muted py-4 bg-white rounded violation-card-empty">
                                    {{ $t('editInspection.noViolations') }}
                                </div>
                                <div class="violation-cards-list">
                                    <div v-for="(item, idx) in violationItems" :key="item.id" class="violation-card"
                                        :class="idx === violationItems.length - 1 ? 'mb-7rem' : ''">
                                        <div class="violation-card-top">
                                            <span class="violation-card-title">{{ item.code || '-' }}</span>
                                            <span class="violation-card-unit">{{ item.unit || '-' }}</span>
                                        </div>
                                        <div class="violation-card-divider"></div>
                                        <p class="violation-card-body text-pre-line mb-0">
                                            {{ item.description && item.description !== 'null' ? item.description : '-' }}
                                        </p>
                                        <div class="violation-card-bottom">
                                            <div class="violation-card-meta d-flex align-items-center">
                                                <div class="table-tags m-0 f-14" v-if="item.oos_status">
                                                    {{ $t('editInspection.oosLabel') }}</div>
                                                <div class="table-tags m-0 f-14" v-if="item.citation_number">
                                                    {{ $t('editInspection.citationNumberLabel') }} {{ item.citation_number
                                                    }}</div>
                                                <!-- <b-form-checkbox v-model="item.oos_status"
                                                    @change="updateViolationData(item)" name="check-button" switch
                                                    size="lg">
                                                    <span class="violation-card-label">{{ $t('editInspection.oosLabel')
                                                    }}</span>
                                                </b-form-checkbox> -->
                                                <!-- <span class="violation-card-stat">
                                                    {{ $t('editInspection.weightLabel') }} <strong>{{ item.weight ?
                                                        item.weight : '-' }}</strong>
                                                </span>
                                                <span class="violation-card-stat">
                                                    {{ $t('editInspection.pointsLabel') }} <strong>{{ item.points ?
                                                        item.points : '-' }}</strong>
                                                </span> -->
                                            </div>
                                            <div class="violation-card-actions">
                                                <svg @click="setViolationData(item)" class="cursor-pointer" width="21"
                                                    height="21" viewBox="0 0 21 21" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M7.9452 17.9664L1.71484 19.7109L3.45934 13.4806L14.8678 2.12751C14.9967 1.99564 15.1508 1.89086 15.3207 1.81932C15.4907 1.74779 15.6733 1.71094 15.8578 1.71094C16.0422 1.71094 16.2248 1.74779 16.3948 1.81932C16.5647 1.89086 16.7188 1.99564 16.8477 2.12751L19.2983 4.59196C19.428 4.72066 19.531 4.87381 19.6014 5.04251C19.6717 5.21123 19.7078 5.3922 19.7078 5.57497C19.7078 5.75774 19.6717 5.93871 19.6014 6.10743C19.531 6.27615 19.428 6.42928 19.2983 6.55798L7.9452 17.9664Z"
                                                        stroke="#2CCE89" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg v-if="allowUpdateRecord" @click="setDeleteViolationData(item.id)"
                                                    class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='documents'>
                        <div class="d-block body mb-7rem">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editInspection.documentsTab')
                                }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    v-if="allowUpdateRecord" @click="$bvModal.show('modal-document')">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editInspection.addDocument') }}</p>
                                </div>
                            </div>
                            <div class="px-4">
                                <div v-if="documentItems.length === 0"
                                    class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                    {{ $t('editInspection.noDocuments') }}
                                </div>
                                <div class="document-cards-list">
                                    <div v-for="item in documentItems" :key="item.pk" class="document-card">
                                        <div class="document-card-top">
                                            <span class="document-card-title">
                                                {{ item.description && item.description !== 'null' ? item.description :
                                                    '-' }}
                                            </span>
                                            <span class="document-card-date">
                                                {{ item.date || '-' }}
                                            </span>
                                        </div>
                                        <div class="document-card-divider"></div>
                                        <div class="document-card-bottom justify-content-end">
                                            <div class="document-card-actions">
                                                <svg @click="setDocumentData(item)" class="cursor-pointer" width="20"
                                                    height="15" viewBox="0 0 20 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg @click="downloadDoc(item)" class="cursor-pointer" width="20"
                                                    height="20" viewBox="0 0 20 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg v-if="allowUpdateRecord" @click="setDeleteDocumentData(item.id)"
                                                    class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="notes">
                        <div class="mt-4rem">
                            <Notes :key="currentDotInspection.id"
                                :noteURL="'app/safety-inspection/' + currentDotInspection.id + '/note'"
                                :allowUpdate="allowUpdateRecord" @updateNotes="$emit('inspectionUpdated', true)" />
                        </div>
                    </v-tab-item>
                    <v-tab-item key="activity">
                        <div class="mt-4rem mb-6rem" v-if="showActivitySection">
                            <ActivityLogs :record="currentDotInspection.record_no" :object_id="currentDotInspection.id"
                                :key="currentDotInspection.id" />
                        </div>
                    </v-tab-item>
                </v-tabs-items>
                <div class="sidebar-footer position-fixed">
                    <div class="d-flex align-items-center justify-content-end">
                        <div class="text-right modal-footer border-0 p-0">
                            <b-button class="mx-0 h-40px w-100px m-0" @click="resetPopup()" variant="secondary"
                                :class="hasChanged && allowUpdateRecord ? 'mr-3' : ''">{{ $t('editInspection.close')
                                }}</b-button>
                            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="onUpdateInspection()"
                                v-if="hasChanged && allowUpdateRecord">{{ $t('editInspection.save') }}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <Violation @violationUpdated="getViolationData" :inspectionID="inspectionID" :violationData="violationData"
            @popupClose="violationData = null" :allowUpdateRecord="allowUpdateRecord" />
        <DeleteModal v-if="showDeleteViolationPopup" @confirm="deleteViolationItem($event)" />
        <DeleteModal v-if="showDeleteInspectionModal" @confirm="deleteInspectionItem($event)" />
        <DeleteModal v-if="showDeleteDocumentPopup" @confirm="deleteDocumentItem($event)"
            :message="`Do you want to delete this doc?`" />
        <Document v-if="currentDotInspection && currentDotInspection.record_no && inspectionPayload.driver"
            :allowUpdateRecord="allowUpdateRecord" :id="inspectionID" @documentsUpdated="getDocumentData"
            :documentItem="documentData" :mediaData="media" :mediaDataID="mediaID" :mediaDataType="mediaType"
            @popupClose="documentData = null" :addDoc="addDotInspectionDoc" :updateDoc="updateDotInspectionDoc"
            :allowVideo="false" :driver="this.driverOptions.filter(
                (item) => item.id === inspectionPayload.driver
            )[0].label" :recordNo="currentDotInspection.record_no" :deleteDocItem="deleteDocumentItem" />
        <DeleteModal v-if="overturnedDataqConfirm" :message="`<p class='f-16 font-weight-normal mb-0'>${$t('editInspection.overturnedDataqConfirm')}<br/>${$t('editInspection.confirmCloseStatus')}</p>`"
            :updateMessage="true" :removeMessage="''" @confirm="verifyOverturnedDataq" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import * as moment from "moment-timezone";
import Violation from './Violation.vue';
import DeleteModal from "@/components/DeleteModal.vue";
import Document from './Document.vue';
import ActivityLogs from "@/components/Shared/ActivityLogs.vue"
import { checkValueExists } from '../../services/helper';
import Notes from "../Shared/Notes";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { pickerDate } from "@/services/helper";
export default {
    name: "EditInspection",
    props: ['inspectionID', 'initialTab'],
    components: { vSelect, Violation, DeleteModal, Document, ActivityLogs, Notes, DatePicker },
    data() {
        return {
            checkValueExists,
            previousStatus: 'New',
            showAdditionalSetting: false,
            overturnedDataqConfirm: false,
            violationID: null,
            defaultData: {},
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
                    if (!value) return null
                    const formats = [
                        'll', 'LL',
                        'MMM D, YYYY', 'MMMM D, YYYY',
                        'M/D/YYYY', 'MM/DD/YYYY',
                        'M-D-YYYY', 'MM-DD-YYYY',
                        'YYYY-MM-DD', 'YYYY/MM/DD',
                        'D MMM YYYY', 'D MMMM YYYY',
                        'D/M/YYYY', 'DD/MM/YYYY',
                    ]
                    const m = moment(value, formats, true)
                    if (m.isValid()) return m.toDate()
                    const lenient = moment(value)
                    return lenient.isValid() ? lenient.toDate() : null
                }
            },
            activeTab: "info",
            states: [],
            documentID: null,
            showDeleteViolationPopup: false,
            showDeleteDocumentPopup: false,
            errors: {},
            showDeleteInspectionModal: false,
            mediaID: null,
            docName: "",
            media: null,
            mediaType: null,
            violationData: null,
            driverOptions: [],
            vehicleOptions: [],
            trailerOptions: [],
            violationItems: [],
            allCitations: [],
            documentItems: [],
            documentData: null,
            currentDocumentPage: 1,
            currentViolationPage: 1,
            violationFields: [
                {
                    key: "code",
                    label: "Code",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "description",
                    label: "Description",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "weight",
                    label: "Weight",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "points",
                    label: "Points",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "oos_status",
                    label: "OOS",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    label: "Unit",
                    key: "unit",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            documentFields: [
                {
                    label: "Description",
                    key: "description",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            inspectionPayload: {
                driver: null,
                record_no: null,
                status: "Closed",
                vehicle: null,
                trailer: null,
                date: null,
                start_time: null,
                end_time: null,
                level: null,
                state: "",
                report_number: '',
                notes: "",
                division: null,
                linked_tickets: [],
                dataq_submitted: false,
                dataq_status: "Not Started",
                dataq_submitted_date: null,
                dataq_decision_date: null,
                dataq_section: false

            },
        }
    },
    computed: {
        ...mapGetters(['currentDotInspection', 'allEquipments', 'allDrivers', 'userCompany', "allCountries", 'rolePermissions', 'divisions']),
        showActivitySection() {
            return this.rolePermissions && this.rolePermissions['Activity Log'] && this.rolePermissions['Activity Log'][0].allow
        },
        allowUpdateRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][1].allow
        },
        allowDeleteRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][3].allow
        },
        yesNoNullOptions() {
            return [
                { value: null, text: '-' },
                { value: false, text: this.$t('safetyShared.no') },
                { value: true, text: this.$t('safetyShared.yes') },
            ];
        },
        dataqStatusOptions() {
            return [
                { value: 'Not Started', text: this.$t('safetyShared.statusNotStarted') },
                { value: 'Submitted', text: this.$t('safetyShared.statusSubmitted') },
                { value: 'Pending', text: this.$t('safetyShared.statusPending') },
                { value: 'Overturned', text: this.$t('safetyShared.statusOverturned') },
                { value: 'Upheld', text: this.$t('safetyShared.statusUpheld') },
            ];
        },
        hasChanged() {
            return Object.keys(this.inspectionPayload).filter(field => {
                if (typeof this.inspectionPayload[field] === 'object') return JSON.stringify(this.inspectionPayload[field]) !== JSON.stringify(this.defaultData[field])
                if (field === 'odometer' || field === 'amount') return this.checkValueExists(this.inspectionPayload[field])?.toString()?.replaceAll(",", "") != this.checkValueExists(this.defaultData[field])?.toString()?.replaceAll(",", "")
                if (field === 'notes') {
                    return this.checkValueExists(this.inspectionPayload[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n')) != this.checkValueExists(this.defaultData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n'));
                }
                else return this.checkValueExists(this.inspectionPayload[field]) != this.checkValueExists(this.defaultData[field])
            }).length > 0
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
        statusOptions() {
            return [
                { value: 'New', text: this.$t('editAccident.statusNew') },
                { value: 'Open', text: this.$t('editAccident.statusOpen') },
                { value: 'Closed', text: this.$t('editAccident.statusClosed') },
                { value: 'Urgent', text: this.$t('editAccident.statusUrgent') }
            ]
        },
        isClosing() {
            return this.inspectionPayload.status === 'Closed';
        },

        dataqDecisionMissing() {
            return this.isClosing && this.inspectionPayload.dataq_section && !this.inspectionPayload.dataq_decision_date;
        },

        citationsNotClosed() {
            if (!this.isClosing || !this.inspectionPayload.linked_tickets.length) return false;
            const openStatuses = ['New', 'Open', 'Urgent'];
            return this.inspectionPayload.linked_tickets.some((id) => {
                const citation = this.allCitations.find((c) => c.id === id);
                return citation && openStatuses.includes(citation.status);
            });
        },

        isCloseBlocked() {
            return this.dataqDecisionMissing || this.citationsNotClosed;
        },

        needsOverturnedDataqConfirm() {
            if (!this.isClosing || !this.inspectionPayload.linked_tickets.length) return false;
            // Only recommend when DataQ hasn't been completed (section not enabled).
            if (this.inspectionPayload.dataq_section) return false;
            return this.inspectionPayload.linked_tickets.some((id) => {
                const citation = this.allCitations.find((c) => c.id === id);
                return citation && citation.court === true && citation.outcome === 'Overturned';
            });
        },
        closeInvalidReason() {
            // Spells out which hard rule is blocking the close.
            if (this.dataqDecisionMissing) return this.$t('editInspection.dataqDecisionRequired');
            if (this.citationsNotClosed) return this.$t('editInspection.citationsNotClosed');
            return '';
        }
    },
    methods: {
        ...mapActions(['getAllCountries', 'getDotInspection', "setLoader", 'getFilteredEquipments', 'getFilteredDrivers', 'getAllViolations', 'deleteViolation', "setNotification", "setLoader", "updateDotInspection", "deleteDotInspection", "getDotInspectionDocs", "updateViolation", "deleteDotInspectionDocument", 'addDotInspectionDoc', 'updateDotInspectionDoc', 'retrieveDocument', 'getAllCitations']),
        async openLink(link) {
            window.open(link, "_blank");
        },
        verifyOverturnedDataq(status) {
            this.overturnedDataqConfirm = false;
            if (!status) {
                // Cancelled — revert to the status before the attempted close.
                this.inspectionPayload.status = this.previousStatus;
                return;
            }
            this.previousStatus = this.inspectionPayload.status;
        },
        goToCitationDetails(item) {
            const citationsData = this.allCitations.find((citation) => citation.id === item)
            this.$router.push(`/safety/citations?recordNo=${citationsData?.label}`)
        },
        getCitationLabel(item) {
            const citationsData = this.allCitations.find((citation) => citation.id === item)
            return `${citationsData?.label}${citationsData?.citation_number ? ` | ${citationsData?.citation_number}` : ''}`
        },
        async openDoc(data) {
            this.docName = data.name
            this.media = data.document
            this.mediaID = data.id
            if (data.document.includes('.pdf')) this.mediaType = 'pdf'
            else if (data.document.includes('.mp4') || data.document.includes('.mkv') || data.document.includes('.mov') || data.document.includes('.avi')) this.mediaType = 'video'
            else this.mediaType = 'image'
        },
        downloadDoc(data) {
            this.docName = data.name
            this.setLoader(true)
            fetch(data.document)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${this.docName}.${data.document.split('.').pop().split(/[#?]/)[0]}`
                    link.click();
                    link.remove()
                    this.setLoader(false)
                })
                .catch(this.setLoader(false));
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onStatusChange(newVal) {
            if (newVal === 'Closed') {
                // Hard blocks (rules 1 & 2) — revert to previous status and show a red alert.
                if (this.isCloseBlocked) {
                    this.setNotification({
                        msg: this.closeInvalidReason,
                        type: "error",
                        color: "red",
                    });
                    this.$nextTick(() => {
                        this.inspectionPayload.status = this.previousStatus;
                    });
                    return;
                }
                // Rule 3 — soft recommendation: overturned court citation without a completed DataQ.
                // Keep previousStatus untouched until the user confirms in the modal.
                if (this.needsOverturnedDataqConfirm) {
                    this.overturnedDataqConfirm = true;
                    return;
                }
            }
            this.previousStatus = newVal;
        },
        validateClose() {
            // Hard blocks (rules 1 & 2) — cannot close until resolved (save-time safety net).
            if (!this.isCloseBlocked) return true;
            this.setNotification({
                msg: this.closeInvalidReason,
                type: "error",
                color: "red",
            });
            return false;
        },
        async onUpdateInspection() {
            if (!this.validateClose()) return;
            try {
                const nullKeys = this.checkNullValues({
                    driver: this.inspectionPayload.driver,
                    date: this.inspectionPayload.date,
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.updateDotInspection({ id: this.inspectionID, payload: { ...this.inspectionPayload, date: moment(this.inspectionPayload.date).format('YYYY-MM-DD'), dataq_submitted_date: this.inspectionPayload.dataq_submitted_date ? moment(this.inspectionPayload.dataq_submitted_date).format('YYYY-MM-DD') : null, dataq_decision_date: this.inspectionPayload.dataq_decision_date ? moment(this.inspectionPayload.dataq_decision_date).format('YYYY-MM-DD') : null } })
                    await this.setNotification({
                        msg: this.$t('editInspection.inspectionUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false);
                    this.$emit("inspectionUpdated", true)
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }
        },
        setDeleteViolationData(id) {
            this.showDeleteViolationPopup = true
            this.violationID = id
        },
        setDeleteDocumentData(id) {
            this.showDeleteDocumentPopup = true
            this.documentID = id
        },
        setDocumentData(data) {
            this.documentData = data
            this.openDoc(data)
            this.$bvModal.show("modal-document");
        },
        async updateViolationData(data) {
            try {
                this.setLoader(true)
                await this.updateViolation({ id: this.inspectionID, payload: { ...data, id: data.id } })
                await this.setNotification({
                    msg: this.$t('violation.violationUpdated'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        setViolationData(data) {
            this.violationData = data
            this.$bvModal.show("modal-violation");
        },
        async deleteInspectionItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteDotInspection({
                        inspectionID: `${this.inspectionID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editInspection.inspectionDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.showDeleteInspectionModal = false
                    this.setLoader(false)
                    this.$emit("inspectionUpdated", true)
                    this.resetPopup()
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.showDeleteInspectionModal = false
            }
        },
        async deleteViolationItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteViolation({
                        inspectionID: this.inspectionID,
                        violationID: `${this.violationID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editInspection.violationDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.getViolationData()
                    this.violationID = null
                    this.showDeleteViolationPopup = false
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.violationID = null
                this.showDeleteViolationPopup = false
            }
        },
        async deleteDocumentItem(status, id = null) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteDotInspectionDocument({
                        inspectionID: this.inspectionID,
                        documentID: `${id ? id : this.documentID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editAccident.docDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.getDocumentData()
                    this.documentID = null
                    this.showDeleteDocumentPopup = false
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.documentID = null
                this.showDeleteDocumentPopup = false
            }
        },

        resetPopup() {
            this.$emit("resetEditInspection", true)
        },
        async searchDriver(searchText) {
            if (searchText) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                driverRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.name,
                    });
                });
                this.driverOptions = this.driverOptions.concat(options)
                this.driverOptions = [...new Map(this.driverOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchVehicle(searchText) {
            if (searchText) {
                let options = [];
                const vehicleRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Vehicle" });
                vehicleRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.vehicleOptions = this.vehicleOptions.concat(options)
                this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchCitations(searchText) {
            if (searchText) {
                let options = []
                let url = `page=1&page_size=25&search=${searchText}`;
                const citationRecords = await this.getAllCitations(url);
                citationRecords.records.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.record_no,
                        citation_number: x.citation_number,
                        status: x.status,
                        court: x.court,
                        outcome: x.outcome
                    });
                });
                this.allCitations = this.allCitations.concat(options)
                this.allCitations = [...new Map(this.allCitations.map(item => [item['id'], item])).values()]
            }
        },
        async searchTrailer(searchText) {
            if (searchText) {
                let options = [];
                const trailerRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Trailer" });
                trailerRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.trailerOptions = this.trailerOptions.concat(options)
                this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
            }
        },
        async getViolationData() {
            this.violationItems = []
            const data = await this.getAllViolations({ id: this.inspectionID })
            data.map((item) => {
                this.violationItems.push({
                    id: item.id,
                    code: item.code,
                    description: item.description,
                    citation_number: item.citation_number,
                    weight: item.weight,
                    points: item.points,
                    oos_status: item.oos_status,
                    unit: item.unit
                })
            })
        },
        async getDocumentData() {
            this.documentItems = []
            const data = await this.getDotInspectionDocs({ id: this.inspectionID })
            data.sort((a, b) => a.description.toLowerCase().localeCompare(b.description.toLowerCase())).map((item) => {
                this.documentItems.push({
                    id: item.id,
                    date: moment(item.date).format('ll'),
                    description: item.description,
                    document: item.document,
                    name: `dot inspection-${this.currentDotInspection.record_no}-${item.description ? item.description : ''}`
                })
            })
        },
        async getCountries() {
            await this.getAllCountries();
            const countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates(countries[0]);
        },
        getStates(selectedOption) {
            this.states = this.allCountries
                .filter((country) => country.id === selectedOption.id)[0]
                .state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
            this.inspectionPayload.state = this.states.filter(
                (state) => state.label === "-"
            )[0].id;
        }
    },
    watch: {
        async inspectionID() {
            if (this.inspectionID) {
                this.activeTab = this.initialTab || 'info'
                try {
                    this.setLoader(true)
                    this.inspectionPayload = {
                        driver: null,
                        record_no: null,
                        status: "Closed",
                        vehicle: null,
                        trailer: null,
                        date: null,
                        start_time: null,
                        end_time: null,
                        level: null,
                        state: "",
                        report_number: '',
                        notes: "",
                        division: null,
                        linked_tickets: [],
                        dataq_submitted: false,
                        dataq_status: "Not Started",
                        dataq_submitted_date: null,
                        dataq_decision_date: null,
                        dataq_section: false
                    }
                    this.errors = {}
                    this.defaultData = {}
                    await this.getCountries();
                    await this.getDotInspection(this.inspectionID)
                    this.inspectionPayload = {
                        record_no: this.currentDotInspection.record_no,
                        driver: this.currentDotInspection.driver,
                        status: this.currentDotInspection.status,
                        vehicle: this.currentDotInspection.vehicle,
                        trailer: this.currentDotInspection.trailer,
                        date: pickerDate(this.currentDotInspection.date),
                        start_time: this.currentDotInspection.start_time,
                        end_time: this.currentDotInspection.end_time,
                        level: this.currentDotInspection.level,
                        state: this.currentDotInspection.state,
                        report_number: this.currentDotInspection.report_number,
                        notes: this.currentDotInspection.notes,
                        division: this.currentDotInspection.division,
                        linked_tickets: this.currentDotInspection.linked_tickets.length ? this.currentDotInspection.linked_tickets.map((item) => item.id) : [],
                        dataq_submitted: this.currentDotInspection.dataq_submitted,
                        dataq_status: this.currentDotInspection.dataq_status,
                        dataq_submitted_date: this.currentDotInspection.dataq_submitted_date ? pickerDate(this.currentDotInspection.dataq_submitted_date) : null,
                        dataq_decision_date: this.currentDotInspection.dataq_decision_date ? pickerDate(this.currentDotInspection.dataq_decision_date) : null,
                        dataq_section: this.currentDotInspection.dataq_section
                    }
                    this.defaultData = JSON.parse(JSON.stringify(this.inspectionPayload))
                    this.previousStatus = this.inspectionPayload.status
                    if (this.currentDotInspection.driver) {
                        this.driverOptions.push({
                            id: this.currentDotInspection.driver,
                            label: this.currentDotInspection.driver_name,
                        })
                    }
                    if (this.currentDotInspection.vehicle) {
                        this.vehicleOptions.push({
                            id: this.currentDotInspection.vehicle,
                            label: this.currentDotInspection.vehicle_name,
                        })
                    }
                    if (this.currentDotInspection.trailer) {
                        this.trailerOptions.push({
                            id: this.currentDotInspection.trailer,
                            label: this.currentDotInspection.trailer_name,
                        })
                    }
                    if (this.currentDotInspection.trailer) {
                        this.trailerOptions.push({
                            id: this.currentDotInspection.trailer,
                            label: this.currentDotInspection.trailer_name,
                        })
                    }
                    if (this.currentDotInspection.linked_tickets.length) {
                        this.allCitations = this.currentDotInspection.linked_tickets.map((item) => {
                            return {
                                id: item.id,
                                label: item.record_no,
                                citation_number: item.citation_number,
                                status: item.status,
                                court: item.court,
                                outcome: item.outcome
                            }
                        })
                    }
                    await this.getViolationData()
                    await this.getDocumentData()
                    this.setLoader(false)
                }
                catch (e) {
                    console.log(e)
                }
            }
        }
    }
}
</script>
<style>
.mw-100px {
    max-width: 100px !important;
}

.violation-cards-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.violation-card {
    background: #FFFFFF;
    border: 1px solid #E2E6F0;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.violation-card-empty {
    border: 1px solid #E2E6F0;
}

.violation-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
}

.violation-card-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.5px;
    color: #222736;
    word-break: break-word;
    text-align: left;
    flex: 1 1 auto;
    min-width: 0;
}

.violation-card-unit {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: #8290AC;
    white-space: nowrap;
}

.violation-card-divider {
    height: 1px;
    width: 100%;
    background: #E2E6F0;
}

.violation-card-body {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.32px;
    color: #222736;
    word-break: break-word;
    text-align: left;
}

.violation-card-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    flex-wrap: wrap;
}

.violation-card-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.violation-card-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: #8290AC;
}

.violation-card-stat {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: #8290AC;
}

.violation-card-stat strong {
    color: #222736;
    font-weight: 500;
}

.violation-card-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.violation-card-icon {
    cursor: pointer;
    flex-shrink: 0;
}

.violation-card-icon:hover {
    opacity: 0.7;
}</style>